module.exports = __webpack_public_path__ + "media/assets/icons/youtube-2a5df08917095c92563e1536faceadae.svg";